<template>
  <el-dialog title="审批流程" :visible.sync="visible" width="552px" :append-to-body="true" center>
    <process-timeline :timeline="timeline"/>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ProcessTimeline from '@/pages/officeApproval/approvalList/components/processTimeline.vue'
import ProcessTimelineMixins from '@/pages/officeApproval/approvalList/components/processTimeline.js'
export default {
  name: "popDelete",
  components: {ProcessTimeline },
  mixins: [ProcessTimelineMixins],
  data() {
    return {
      visible: false,
    }
  },
  created() {
    
    
  },
  methods: {
    show(processInstanceId) {
      this.getTimeline({processInstanceId})
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/{
  .el-dialog__body{ 
    padding: 16px 32px 0;
  }
  .el-dialog__footer{
    padding-top: 0;
  }
}
</style>
